<app-auth [isAtLeastMedium]="isAtLeastMedium">
  <div layout-body>
    <form novalidate class="mb-5" name="Fuser">
            <div class="login-content">
                <div *ngIf="!passwordChanged">

                    <div class="connect py-3">
                        <div class="icon-box info"><i class="fa fa-undo"></i>
                        </div>
                        <div class="header-content mt-4">
                            <div class="title-connect">Nouveau mot de passe</div>
                        </div>
                    </div>   

                    <div class="connect">

                        <div class="header-content">
                            <div class="subtitle">
                                 Choisissez un nouveau mot de passe unique et gardez le précieusement.
                            </div>

                            <form novalidate class="container-fluid" [hidden]="isValidated" class="content">
                                <div class="fields">
                                    <div class="change-password forget">
                                        <stInput name="password" type="password" innerId="password" 
                                            [(ngModel)]="password" placeholder="Choisissez votre mot de passe" 
                                            class="custom-placeholder"
                                            (ngModelChange)="validatePassword()"
                                            [class.isInvalid]="!isPasswordValid">
                                        </stInput>
                                    </div>
                               <div class="hint" [ngClass]="{ 'invalid-hint': !isPasswordValid && password }">
                                Au moins 8 caractères, dont 1 chiffre, 1 majuscule et un caractère spécial ? ! / , ;
                                </div>
                                    <div class="btn-full-width w-100">
                                        <stButton btnLabel="Réinitialiser mon mot de passe" btnClass="btn-color" [isDisabled]="!isPasswordValid" [hidden]="isValidated"
                                            (onClick)="validate()"></stButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div *ngIf="passwordChanged">
                    <div class="header connect">
                        <div class="icon-box info"><i class="fa fa-envelope small-icon"></i></div>
                        <div class="header-content">
                            <div class="title-connect mt-4">Mot de passe enregistré</div>
                            <div class="subtitle">
                                Votre nouveau mot de passe a été enregistré.<br />Vous pouvez dès à présent vous
                connecter.
                            </div>
                        </div>
                    </div>
                </div>
                <a routerLink="/" class="btn-connect btn-forget-pwd"><i class="fa fa-arrow-left size-arrow"></i>&nbsp; Se connecter</a>
            </div>
    </form>
  </div>
</app-auth>


